<template>
  <div>
    <div class="form-container ou-donation-form esp">
      <div class="holder">
          <div class="holder__links">*For english click here <a href="https://chile.ncsy.org/donate2/">aquí</a></div>
        <div class="holder__links">
        *Para donar con tarjeta chilena, haz click <a href="https://chile.ncsy.org/sumate/">aquí</a></div>
        <br/>
        <PaymentForm class="form-horizontal">
          <FormSection title="Apóyanos">
            <div class="frequency">
              <PaymentOptions
                addMonthly
                monthlyText="Donación Mensual"
                oneTimeText="Donación única"
                lang="esp"
              />
            </div>
          </FormSection>
          <FormSection title="Para que te hagas una idea…">
            <div class="donation__list">
              <ul>
                <li>Una semana de NCSY cuesta - <span>$6250 - US Dollars</span></li>
                <li>Un alumno al año cuesta - <span>$1400 - US Dollars</span></li>
                <li>Un grupo semanal de NCSY cuesta - <span>$300 - US Dollars</span></li>
                <li>Un alumno al mes cuesta - <span>$115 - US Dollars</span></li>
              </ul>
            </div>
          </FormSection>
          <FormSection title="Monto de tu Donación">
            <div class="chile__group">
              <AmountSelectorSimple />
              <div class="chile__amount">Dólares</div>
              <ErrorLabel field="amount" />
            </div>
            <br />
            <div>
              <FormRow inline>
                <FormCol
                  field="custom.listingName"
                  width="half"
                  :showLabel="false"
                  class="forceShow"
                >
                  <label class="control-label">nombre para la dedicatoria</label>
                  <FormInput type="text" />
                </FormCol>
              </FormRow>
              <FormRow inline class="forceShow">
                <label class="control-label"
                  ><span>Dedicatoria</span>
                  <FormCol :showLabel="false" field="dedicationMessage" width="half"/>
                </label>
              </FormRow>
            </div>
          </FormSection>
          <FormSection title="Tus detalles">
            <FormRow inline>
              <FormCol field="title" lang="esp" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                <Consent privacy="https://ncsy.org/privacy-policy/" lang="esp"/>
                    </FormRow> 
          </FormSection>
          <FormSection title="Datos de facturación">
            <DonorAddress />
          </FormSection>
          <FormSection title="Información del pago" last>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton showAmount btnText="Donar" />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { onMounted } from "vue";
import { defineComponent } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";
import { queryParams } from "~/shared/query-params";

export default defineComponent({
  props: {
    subCampaign: String,
    campaign: String,
  },
  setup(props) {
    const { setValue, form, submit } = usePaymentForm();

    if (props.subCampaign) {
      setValue("applications.0.subCampaign", props.subCampaign);
    }

    if (props.campaign) {
      setValue("applications.0.campaign", props.campaign);
    }

    onMounted(() => {
      const params = queryParams();

      if (params.utm_content) {
        if (
          !["Direct Mail", "Telemarketing", "Text SMS Message"].includes(
            params.utm_content
          )
        ) {
          throw new Error("Invalid subcampaign");
        }

        setValue("applications.0.subCampaign", params.utm_content);
      }
    });

    return {
      form,
      submit,
    };
  },
});
</script>
<style scoped lang="scss">
h2 {
  font-weight: 400;
  margin-bottom: 20px;
  margin-top: 20px;
  font-size: 20px;
  color: black;
}
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.ou-donation-form ::v-deep h2 {
  font-size: 20px;
  text-transform: none;
  letter-spacing: normal;
}

.ou-donation-form ::v-deep .styled-radio-container--ou-donation {
  label {
    font-size: 14px !important;
  }
  &.styled-radio-container {
    label {
      font-size: 14px !important;
    }
    .radio-part {
      min-width: 28%;
      label {
        font-size: 14px !important;
      }
    }
  }
}
.ou-donation-form ::v-deep .forceShow label {
  font-size: 14px !important;
}

label.newsletter__label {
  padding-left: 7px;
}
.control-label {
  flex: 1;
  font-size: 14px;
  padding-top: 3px;
  padding-bottom: 3px;
  display: block;
  color: #222;
  span {
    margin-bottom: 5px;
    padding-bottom: 3px;
    display: block;
  }
}

.donation__list {
  ul {
    padding: 0px 0px;
    margin: 0px 0px 11px;
    display: flex;
    flex-flow: wrap;
    gap: 1%;
    li {
      width: 49%;
      padding: 8px 2px;
      margin-bottom: 8px;
      background: #fafafa;
      text-align: center;
      border: 1px solid #cacaca;
      span {
        font-weight: bold;
        display: block;
        font-size: 16px;
      }
    }
  }
}
.chile__group {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 15px;
}
.ou-donation-form ::v-deep .styled-radio-container--ou-donation.styled-radio-container {
  .radio-part {
      	@media only screen and (min-width: 720px) {
      min-width:200px;
      max-width: 200px;
    }
  }
}
.holder__links {
    font-size: 18px;
    line-height: normal;
    color: black;
    font-weight: 600;
    padding-bottom: 5px;
    a{
      font-size: 18px;
    line-height: normal;
    font-weight: 600;
    }
}
</style>
